import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import {
  selectCurrentUserCompanyId,
  selectCurrentUserType,
} from '@reducers/currentUser/currentUserSelectors'
import {
  selectShellUserCompanyId,
  selectShellUserLenderId,
  selectShellUserType,
} from '@reducers/shellUser/shellUserSelectors'
import analytics from '@helpers/segmentAnalytics'

const useSignupAnalyticsTracker = () => {
  const currentUserCompanyId = useSelector(selectCurrentUserCompanyId)
  const shellUserCompanyId = useSelector(selectShellUserCompanyId)
  const shellUserLenderId = useSelector(selectShellUserLenderId)
  const shellUserUserType = useSelector(selectShellUserType)
  const currentUserUserType = useSelector(selectCurrentUserType)
  const companyId = shellUserCompanyId || currentUserCompanyId
  const userType = shellUserUserType || currentUserUserType

  return useCallback(({ eventName, payload = {} }) => {
    const updatedPayload = {
      ...payload,
      company_id: companyId,
      lender_id: shellUserLenderId,
      user_type: userType,
    }
    analytics.track(eventName, updatedPayload)
  }, [
    companyId,
    shellUserLenderId,
    userType,
  ])
}

export default useSignupAnalyticsTracker
